import { useEffect, useState } from "react";
import "../styles/challenge-theme.css";
import moment from "moment";
import Button from "../../../../ui/atoms/buttons/Button";
import NotFound from "../../../../ui/organisms/not-found/404";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  capitalizeAll,
  isEmpty,
  slugify,
} from "../../../../core/utils/helpers";
import { onGetChallengeThemesWithPagination } from "../../services/challengeTheme";
import StatusComponent from "../../../../ui/atoms/status/StatusComponent";
import { challengeSlice } from "../../../../app/store/slices/challengeSlice";
import useAxiosPrivate from "../../../../app/providers/context-provider/useAxiosPrivate";

const ChallengeTheme = () => {
  const { category_en, category_fr } = useParams();
  const axiosPrivate = useAxiosPrivate();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [challengeThemesData, setChallengeThemesData] = useState({});
  const rowsPerPage = 10;
  const [currentPage, setCurrentPage] = useState(1);
  //
  const [selectedRows, setSelectedRows] = useState([]);
  const [checkedRows, setCheckedRows] = useState([]);
  const [checkedChallengeTheme, setCheckedChallengeTheme] = useState([]);

  const currentChallengeThemeCategory = useSelector(
    (state) => state?.challengeState?.currentChallengeThemeCategory,
  );

  const _current_challenge_theme_category_id =
    currentChallengeThemeCategory?.id;

  const _current_challenge_theme_category_title_en =
    currentChallengeThemeCategory?.title_en;
  const _current_challenge_theme_category_title_fr =
    currentChallengeThemeCategory?.title_fr;

  useEffect(() => {
    let isMounted = true;
    const controller = new AbortController();
    const signal = controller.signal;

    const _localData = {
      challenge_theme_category_id: _current_challenge_theme_category_id,
      rows_per_page: rowsPerPage,
      current_page: currentPage,
    };

    onGetChallengeThemesWithPagination(axiosPrivate, _localData, signal).then(
      (response) => {
        const _data = response?.data;
        setChallengeThemesData(_data);
      },
    );

    return () => {
      isMounted = false;
      isMounted && controller.abort();
    };
  }, [rowsPerPage, currentPage]);

  const onHandleSelectRow = (id) => {
    setSelectedRows((prevSelected) =>
      prevSelected.includes(id)
        ? prevSelected.filter((item) => item !== id)
        : [...prevSelected, id],
    );
    setCheckedRows((prevSelected) =>
      prevSelected.includes(id)
        ? prevSelected.filter((item) => item !== id)
        : [...prevSelected, id],
    );
  };

  const onHandleSelectCurrentChallengeTheme = (challenge_theme) => {
    setCheckedChallengeTheme((prevSelected) =>
      prevSelected.some((item) => item.id === challenge_theme.id)
        ? prevSelected.filter((item) => item.id !== challenge_theme.id)
        : [...prevSelected, challenge_theme],
    );
  };

  const onHandleSelectAll = (e) => {
    const isChecked = e.target.checked;
    if (isChecked) {
      const allChallengeThemeIds = challengeThemesData?.result?.map(
        (item) => item.id,
      );
      setSelectedRows(allChallengeThemeIds);
      setCheckedRows(allChallengeThemeIds);
    } else {
      setSelectedRows([]);
      setCheckedRows([]);
    }
  };
  const isAllSelected =
    selectedRows?.length === challengeThemesData?.result?.length;

  return (
    <div className="challenge-themes">
      <div className="challenge-theme-head">
        <h1>Challenge Theme Management</h1>
        <h3 style={{ color: "grey" }}>
          Category : {capitalizeAll(_current_challenge_theme_category_title_en)}{" "}
          / {capitalizeAll(_current_challenge_theme_category_title_fr)}
        </h3>
        <div className="w-full d-flex justify-space-between">
          <Button
            type={"button"}
            preferedStyle={"default"}
            title={"⬅️ Back to ..."}
            action={() => navigate(-1)}
          />
          <Button
            type={"button"}
            preferedStyle={"default"}
            title={"➕ Create new Challenge Theme"}
            action={() =>
              navigate(
                `/admin/challenge/themes/${category_en}/${category_fr}/create`,
              )
            }
          />
          {selectedRows.length > 0 && (
            <div className="c-t-actions fade-in">
              {selectedRows.length === 1 && (
                <>
                  <Button
                    type={"button"}
                    preferedStyle={"default"}
                    title={"👁️ Voir details"}
                    action={() => {
                      dispatch(
                        challengeSlice.actions.onCurrentChallengeTheme(
                          checkedChallengeTheme[0],
                        ),
                      );
                      // navigate(`/admin/users/details?userId=${selectedRows[0]}`);
                    }}
                  />
                  <Button
                    type={"button"}
                    preferedStyle={"default"}
                    title={"🔄 Update infos"}
                    action={() => navigate("/admin/users/update")}
                  />
                </>
              )}
              <Button
                type={"button"}
                preferedStyle={"default"}
                title={"🔐 Activate or Desactivate account"}
                action={""}
              />
            </div>
          )}
        </div>
      </div>
      <div className="challenge-theme-body">
        {isEmpty(challengeThemesData?.result) ? (
          <NotFound
            type={"data"}
            title={"No Challenge Theme found!"}
            text={"No Challenge Theme available yet."}
            isBoutton={false}
          />
        ) : (
          <>
            <div className="table">
              <table>
                <thead>
                  <tr>
                    <th className="col-05 text-align-center">
                      <input
                        type="checkbox"
                        checked={isAllSelected}
                        onChange={onHandleSelectAll}
                      />
                    </th>
                    <th className="col-20 text-align-left">Date of creation</th>
                    <th className="col-30 text-align-left">
                      Challenge's Title
                    </th>
                    <th className="col-10 text-align-center">Linked Streams</th>
                    <th className="col-10 text-align-center">
                      Total Questions
                    </th>
                    <th className="col-10 text-align-left">Visibility</th>
                    <th className="col-10 text-align-left">Availability</th>
                    <th className="col-05 text-align-left">Action</th>
                  </tr>
                </thead>
                <tbody>
                  {challengeThemesData?.result?.map((item, idx) => {
                    return (
                      <tr
                        key={idx}
                        className={
                          checkedRows.includes(item.id) ? "row-checked" : ""
                        }
                      >
                        <td className="col-05 text-align-center">
                          <input
                            type="checkbox"
                            checked={selectedRows.includes(item.id)}
                            onChange={() => {
                              onHandleSelectCurrentChallengeTheme(item);
                              onHandleSelectRow(item.id);
                            }}
                          />
                        </td>
                        <td className="col-20 text-align-left">
                          {moment(item?.created_at).format("LLLL")}
                        </td>
                        <td className="col-30 text-align-left">
                          <div className="td-col">
                            <span className="span-names">
                              {capitalizeAll(item?.title_en)}
                            </span>
                            <span className="span-mail">
                              {capitalizeAll(item?.title_fr)}
                            </span>
                          </div>
                        </td>
                        <td className="col-10 text-align-center">
                          {item?.total_linked_classes}
                        </td>
                        <td className="col-10 text-align-center">
                          <span className="span-role">
                            {item?.total_questions}
                          </span>
                        </td>
                        <td className="col-10 text-align-left">
                          <StatusComponent
                            type={item?.is_activated ? "success" : "error"}
                            title={
                              item?.is_activated ? "Released" : "UnReleased"
                            }
                          />
                        </td>
                        <td className="col-10 text-align-left">
                          <StatusComponent
                            type={item?.is_deleted ? "error" : "success"}
                            title={item?.is_deleted ? "Archived" : "UnArchived"}
                          />
                        </td>
                        <td className="col-10 text-align-left">
                          <Button
                            type={"button"}
                            preferedStyle={"default"}
                            title={"⁉️ Setup Questions"}
                            action={() => {
                              dispatch(
                                challengeSlice.actions.onCurrentChallengeTheme(
                                  item,
                                ),
                              );
                              navigate(
                                `/admin/challenge/themes/${item.id}/${slugify(item?.title_en)}/${slugify(item?.title_fr)}/questions`,
                              );
                            }}
                          />
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
            <div className="pagination">
              <div className="p-wrapper">
                <button
                  className={
                    challengeThemesData?.result_complements?.current_page === 1
                      ? "button is-inactive"
                      : "button is-active"
                  }
                  onClick={() => {
                    setCurrentPage((prev) => (prev > 1 ? prev - 1 : 1));
                    setSelectedRows([]);
                  }}
                  disabled={
                    challengeThemesData?.result_complements?.current_page === 1
                  }
                >
                  Previous
                </button>
                <span>
                  Page {currentPage} of{" "}
                  {challengeThemesData?.result_complements?.total_pages} pages.
                </span>
                <button
                  className={
                    challengeThemesData?.result_complements?.current_page ===
                    challengeThemesData?.result_complements?.total_pages
                      ? "button is-inactive"
                      : "button is-active"
                  }
                  onClick={() => {
                    setCurrentPage((prev) =>
                      prev <=
                      challengeThemesData?.result_complements?.total_pages
                        ? prev + 1
                        : prev,
                    );
                    setSelectedRows([]);
                  }}
                  disabled={
                    challengeThemesData?.result_complements?.current_page ===
                    challengeThemesData?.result_complements?.total_pages
                  }
                >
                  Next
                </button>
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default ChallengeTheme;
